<div class="notification-settings">
  <div class="settings-header">
    <h1>Notification Settings</h1>
    <p class="header-description">Manage your daily reminder notifications</p>
  </div>

  <form [formGroup]="settingsForm" (ngSubmit)="onSaveSettings()" class="settings-form">
    <div class="reminders-section">
      <div class="section-header">
        <h2>Daily Reminders</h2>
        <button type="button" class="add-reminder-btn" (click)="addReminder()">
          <span class="plus-icon">+</span>
          Add Reminder
        </button>
      </div>

      <div formArrayName="reminders" class="reminders-list">
        <div *ngFor="let reminderForm of reminders.controls; let i = index" [formGroupName]="i" class="reminder-item">
          <div class="reminder-content">
            <div class="reminder-header">
              <input type="text" formControlName="label" placeholder="Reminder label" class="reminder-label-input" />
              <div class="reminder-main-controls">
                <input type="time" formControlName="time" class="reminder-time-input" />
                <label class="toggle-switch">
                  <input type="checkbox" formControlName="enabled" />
                  <span class="toggle-slider"></span>
                </label>
                <button
                  *ngIf="reminders.length > 1"
                  type="button"
                  class="remove-btn"
                  (click)="removeReminder(i)"
                  title="Remove reminder"
                >
                  ×
                </button>
              </div>
            </div>

            <div class="days-selection">
              <div class="days-label">Days:</div>
              <div class="days-buttons">
                <button
                  *ngFor="let day of daysOfWeek"
                  type="button"
                  class="day-btn"
                  [class.selected]="isDaySelected(i, day.id)"
                  (click)="toggleDay(i, day.id)"
                >
                  {{ day.short }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <!-- <button type="button" class="test-button" (click)="onSendTestNotification()">Test Notification</button> -->
      <button type="submit" class="save-button" [disabled]="!settingsForm.valid">Save Settings</button>
    </div>
  </form>
</div>
